import { render, staticRenderFns } from "./order-by.vue?vue&type=template&id=4b5e2182&"
import script from "./order-by.vue?vue&type=script&lang=js&"
export * from "./order-by.vue?vue&type=script&lang=js&"
import style0 from "./order-by.vue?vue&type=style&index=0&id=4b5e2182&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports